import { render, staticRenderFns } from "./ProcessSteps.vue?vue&type=template&id=5fb0c561"
import script from "./ProcessSteps.vue?vue&type=script&lang=js"
export * from "./ProcessSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports